import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as Cookies from 'js-cookie';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import { withStyles } from '@material-ui/styles';
import classNames from 'classnames';
import Switch from 'components/forms/Switch';
import { useOutsideClick } from 'utils/hooks';


const styles = theme => ({
  wrapper: {
    position: 'relative',
  },
  button: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: theme.palette.secondary[900],
    display: 'flex',
    alignItems: 'center',
    fontSize: '0.75rem',
    fontWeight: 600,
    borderRadius: '0.375rem',
    height: '2rem',
    padding: '0 0.75rem',
  },
  isOpen: {
    background: '#F0F3F7',
  },
  icon: {
    marginRight: '0.313rem',
    marginTop: '-0.063rem',
  },
  modal: {
    position: 'absolute',
    left: '0',
    width: '18rem',
    background: theme.palette.white,
    padding: '1.375rem 1rem 1rem 1rem',
    boxShadow: theme.shadows[2],
    zIndex: 2,
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '0.875rem',
    fontWeight: 500,
    marginBottom: '0',
  },
  bottomWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '1rem',
    gap: '0.5rem',
  },
  bottomButton: {
    background: 'none',
    border: `1px solid ${theme.palette.secondary[200]}`,
    borderRadius: '0.375rem',
    cursor: 'pointer',
    color: theme.palette.secondary[900],
    flex: 1,
    height: '2rem',
    fontSize: '0.875rem',
    fontWeight: 600,
  },
});

const HideFields = ({
  classes,
  fieldsToShow,
  onFieldsToShowChange,
  cookieKey,
  style,
}) => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const ref = useOutsideClick(() => {
    if (isOpenModal) setIsOpenModal(false);
  });
  const sortedFieldsToShow = Object.keys(fieldsToShow).sort((a, b) => {
    if (a < b) {
      return -1;
    }
    if (a > b) {
      return 1;
    }
    return 0;
  });

  const handleShowAll = () => {
    onFieldsToShowChange(Object.keys(fieldsToShow)
      .reduce((acc, key) => ({ ...acc, [key]: { ...fieldsToShow[key], show: true } }), {}));
    Cookies.set(cookieKey, Object.keys(fieldsToShow).reduce((acc, key) => ({ ...acc, [key]: true }), {}));
  };

  const handleHideAll = () => {
    onFieldsToShowChange(Object.keys(fieldsToShow)
      .reduce((acc, key) => ({ ...acc, [key]: { ...fieldsToShow[key], show: false } }), {}));
    Cookies.set(cookieKey, Object.keys(fieldsToShow).reduce((acc, key) => ({ ...acc, [key]: false }), {}));
  };

  const handleVisibilityToggle = key => (e) => {
    const { checked } = e.target;
    Cookies.set(
      cookieKey,
      Object.keys(fieldsToShow).reduce((acc, fieldKey) => {
        if (fieldKey === key) return { ...acc, [fieldKey]: checked };
        return { ...acc, [fieldKey]: fieldsToShow[fieldKey].show };
      }, {}),
    );
    onFieldsToShowChange({
      ...fieldsToShow,
      [key]: { ...fieldsToShow[key], show: checked },
    });
  };

  return (
    <div className={classes.wrapper} ref={ref} style={style}>
      <button
        className={classNames(classes.button, { [classes.isOpen]: isOpenModal })}
        onClick={() => setIsOpenModal(!isOpenModal)}
      >
        <VisibilityOutlinedIcon className={classes.icon} />Hide Fields
      </button>
      {isOpenModal && (
        <div className={classes.modal}>
          {sortedFieldsToShow.map(field => (
            <>
              {/* eslint-disable jsx-a11y/label-has-for */}
              <label className={classes.label}>
                <Switch
                  size="small"
                  onChange={handleVisibilityToggle(field)}
                  checked={Boolean(fieldsToShow[field].show)}
                />
                {fieldsToShow[field].label}
              </label>
            </>
          ))}
          <div className={classes.bottomWrapper}>
            <button
              className={classes.bottomButton}
              onClick={handleHideAll}
            >
              Hide All
            </button>
            <button
              className={classes.bottomButton}
              onClick={handleShowAll}
            >
              Show All
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

HideFields.propTypes = {
  classes: PropTypes.element.isRequired,
  fieldsToShow: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    show: PropTypes.bool.isRequired,
  })).isRequired,
  onFieldsToShowChange: PropTypes.func.isRequired,
  cookieKey: PropTypes.string.isRequired,
  style: PropTypes.shape({}),
};

HideFields.defaultProps = {
  style: {},
};

export default withStyles(styles)(HideFields);
